import { Link } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import CategoryBand from "./components/CategoryBand";
import SeriesSection from "./components/SeriesSection";
import TodayBoard from "./components/TodayBoard";
import CompareSection from "./components/CompareSection";
import PandianSection from "./components/PandianSection";
import WhySection from "./components/WhySection";
import FaqPreview from "./components/FaqPreview";
import { useSeo } from "@/hooks/useSeo";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "热瓜雷达",
  description: "把全网热瓜同类事件摆在一起看的专题盘点与对比分析平台",
  url: "https://w01xfj.cn/",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://w01xfj.cn/pandian?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  useSeo({
    title: "全网热瓜·热瓜雷达｜同类盘点与系列事件对比分析",
    description:
      "热瓜雷达专注全网热瓜同类盘点、系列事件与对比分析，按时间线串联梳理相似剧情与后续走向。今日热榜实时更新，冷静吃瓜、拒绝网暴。",
    canonical: "https://w01xfj.cn/",
    jsonLd,
  });

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <SeriesSection />
        <TodayBoard />
        <CompareSection />
        <PandianSection />
        <WhySection />
        <FaqPreview />
        <section className="border-t border-background-200 bg-background-100/60">
          <div className="mx-auto flex max-w-container flex-col items-center px-4 py-12 text-center md:py-14 md:px-6">
            <h2 className="text-2xl text-foreground-950 md:text-3xl">今天的热瓜，你摸清了吗？</h2>
            <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              与其在热搜里拼凑碎片，不如让热瓜雷达帮你把系列、同类与对比一次看清。冷静吃瓜，从关注我们开始。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link to="/#series" className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-medium text-background-50 transition hover:bg-primary-400">
                回到顶部追系列
              </Link>
              <Link to="/faq" className="inline-flex h-11 items-center justify-center whitespace-nowrap rounded-full border border-primary-300 px-6 text-sm text-primary-700 transition hover:bg-primary-100">
                有疑问先看 FAQ
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}